class CartAttributes extends HTMLElement {
  constructor() {
    super();
    console.log('CartAttributes component initialized');
    
    // Simple debounce function
    this.debounceTimer = null;
    
    // Listen for changes on radio buttons
    this.addEventListener("change", (event) => {
      console.log('Change event fired:', event.target.name, event.target.value);
      if (event.target.name && event.target.name.startsWith('attributes[')) {
        this.clearFieldError(event.target.name);
        this.debouncedUpdate();
      }
    });

    // Listen for input on text fields
    this.addEventListener("input", (event) => {
      console.log('Input event fired:', event.target.name, event.target.value);
      if (event.target.name && event.target.name.startsWith('attributes[')) {
        this.clearFieldError(event.target.name);
        this.debouncedUpdate();
      }
    });

    // Add form submission validation
    this.setupFormValidation();
  }

  setupFormValidation() {
    // Delay setup to ensure DOM is ready
    const setupValidation = () => {
      // Find all cart forms and add validation
      const cartForms = document.querySelectorAll('form[action="/cart"]');
      cartForms.forEach(form => {
        form.addEventListener('submit', (event) => {
          if (!this.validateRequiredFields()) {
            event.preventDefault();
            event.stopPropagation();
            return false;
          }
        });
      });

      // Also listen for checkout button clicks directly
      document.addEventListener('click', (event) => {
        if (event.target.name === 'checkout' || 
            event.target.closest('button[name="checkout"]') ||
            event.target.closest('input[name="checkout"]')) {
          if (!this.validateRequiredFields()) {
            event.preventDefault();
            event.stopPropagation();
            return false;
          }
        }
      });
    };

    // Setup immediately if DOM is ready, otherwise wait
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupValidation);
    } else {
      setupValidation();
    }
  }

  validateRequiredFields() {
    let isValid = true;
    
    // Check User Type
    const userTypeSelected = document.querySelector('input[name="attributes[user-type]"]:checked');
    if (!userTypeSelected) {
      this.showFieldError('user-type', 'Please select a user type');
      isValid = false;
    }
    
    // Check Project Type
    const projectTypeSelected = document.querySelector('input[name="attributes[project-type]"]:checked');
    if (!projectTypeSelected) {
      this.showFieldError('project-type', 'Please select a project type');
      isValid = false;
    }
    
    // Check Project Square Footage
    const squareFootageInput = document.querySelector('input[name="attributes[project-square-footage]"]');
    if (!squareFootageInput || !squareFootageInput.value.trim()) {
      this.showFieldError('project-square-footage', 'Please enter project square footage');
      isValid = false;
    }
    
    if (!isValid) {
      // Scroll to first error
      const firstError = document.querySelector('.text-red-600:not(.hidden)');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    
    return isValid;
  }

  showFieldError(fieldName, message) {
    const errorElement = document.getElementById(`${fieldName}-error`);
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.classList.remove('hidden');
    }
  }

  clearFieldError(fieldName) {
    // Extract field name from attributes[field-name] format
    const match = fieldName.match(/attributes\[([^\]]+)\]/);
    if (match) {
      const cleanFieldName = match[1];
      const errorElement = document.getElementById(`${cleanFieldName}-error`);
      if (errorElement) {
        errorElement.classList.add('hidden');
      }
    }
  }
  
  debouncedUpdate() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.updateAttributes();
    }, 300);
  }

  updateAttributes() {
    console.log('Updating attributes...');
    const attributes = {};
    
    // Collect all attribute values
    this.querySelectorAll('input[name^="attributes["]').forEach(input => {
      if (input.type === 'radio') {
        if (input.checked) {
          const name = input.name.slice(11, -1); // Remove 'attributes[' and ']'
          attributes[name] = input.value;
          console.log(`Adding radio attribute: ${name} = ${input.value}`);
        }
      } else {
        const name = input.name.slice(11, -1); // Remove 'attributes[' and ']'
        if (input.value.trim()) {
          attributes[name] = input.value.trim();
          console.log(`Adding text attribute: ${name} = ${input.value.trim()}`);
        }
      }
    });

    const body = JSON.stringify({ attributes });
    console.log('Sending cart update request with body:', body);
    fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => {
        console.log('Response status:', response.status);
        console.log('Response headers:', response.headers);
        
        if (!response.ok) {
          return response.text().then(text => {
            console.log('Error response text:', text);
            throw new Error(`HTTP ${response.status}: ${text}`);
          });
        }
        
        // Try JSON first, fallback to text
        return response.text().then(text => {
          try {
            const json = JSON.parse(text);
            console.log('Cart update response (JSON):', json);
            return json;
          } catch (e) {
            console.log('Cart update response (text):', text);
            return text;
          }
        });
      })
      .catch(error => {
        console.error('Cart update error:', error);
      });
  }
}

customElements.define("cart-attributes", CartAttributes);
console.log('CartAttributes component registered');

// Global validation for cart attributes
window.validateCartAttributes = function() {
  const cartAttributes = document.querySelector('cart-attributes');
  if (cartAttributes) {
    return cartAttributes.validateRequiredFields();
  }
  return true;
}; 